import { createApiClient } from "../apiService";
import { getSubdomain } from "../../utils/getSubdomain/subdomain";
import { ConsumeMagicLinkPayload, MagicLinkConsumeResponse, SuccessType } from "./magicLinksTypes";

const domain = getSubdomain();
const apiClient = createApiClient("");

const consumeMagicLink = async (data: ConsumeMagicLinkPayload): Promise<MagicLinkConsumeResponse> => {
    // Usamos el domain (subdomain) como publication_slug tal como espera tu backend
    const path = `/magic-links/${domain}/consume`;
    
    const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
    };

    const res = await apiClient.post(path, data, { headers });
    return res.data as MagicLinkConsumeResponse;
};

const regenerateMagicLink = async (data: ConsumeMagicLinkPayload): Promise<SuccessType> => {
    const path = `/magic-links/${domain}/regenerate`;
    
    const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
    };

    const res = await apiClient.post(path, data, { headers });
    return res.data as SuccessType;
}

const magicLinksService = {
    consumeMagicLink,
    regenerateMagicLink
};

export default magicLinksService;